module.exports = __webpack_public_path__ + "frontend-assets/img/games_icon-hover.8ee1543f.png";